// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + "99ca4323230d9ece8d5e" + ".css";
};